import securedWebStorage from '@/main';

// filterModule.js
export default {
  namespaced: true, // Habilita el namespace para el módulo
  state: {
    defaultDateStartFilter: '',
    defaultDateEndFilter: '',
    dateStartFilter: '',
    dateEndFilter: '',

    allField: [],
    defaultFieldFilter: [],
    fieldFilter: [],

    textFilter: '',
    clientFilter: '',
    zoneFilter: [],
    zonesFilter: [],
    typeFilter: '',
    statusFilter: '',
    planFilter: '',
    imeiFilter: '',
    plateFilter: '',
    aliasFilter: '',
    userFilter: '',
    nameFilter: '',
    emailFilter: '',
    phoneFilter: '',
    brandFilter: '',
    modelFilter: '',
    speedFilter: 120,
    speedTypeFilter: 1,
    mileageFilter: 60,
    mileageTypeFilter: 0,
    minuteFilter: 60,
    minuteTypeFilter: 0,
    daysFilter: 30,
    daysTypeFilter: 1,
    platesFilter: [],
    platesPlateFilter: [],
    massivePlatesFilter: "",
    massiveChasisNumbersFilter: '',
    vehicleGroupsFilter: [],
    companyFilter: '',
    highwayFilter: '',
    porchFilter: '',
    typeFilter: '',    
    statusAlertFilter: '',
    resultAlertFilter: '',
    typeDeviceFileter: '',
    typeVehicleFilter: '',
    filterConfig: {
      showConfigFilter: false,
      showDateStartFilter: false,
      showDateEndFilter: false,
      withTime: false,
      showClientFilter: false,
      showZoneFilter: false,
      showZonesFilter: false,
      showTypeFilter: false,
      showStatusFilter: false,
      showPlanFilter: false,
      showTextFilter: false,
      showImeiFilter: false,
      showPlateFilter: false,
      showAliasFilter: false,
      showUserFilter: false,
      showNameFilter: false,
      showEmailFilter: false,
      showPhoneFilter: false,
      showBrandFilter: false,
      showModelFilter: false,
      showSpeedFilter: false,
      showSpeedTypeFilter: false,
      showMileageFilter: false,
      showMileageTypeFilter: false,
      showMinuteFilter: false,
      showMinuteTypeFilter: false,
      showDaysFilter: false,
      showDaysTypeFilter: false,
      showPlatesFilter: false,
      showPlatesPlateFilter: false,
      showMassivePlatesFilter: false,
      showMassiveChasisNumbersFilter: false,
      showVehicleGroupsFilter: false,
      showCompanyFilter: false,
      protectOnlyFilter: false,
      showHighwayFilter: false,
      showPorchFilter: false,
      showStatusAlertFilter: false,
      showTypeAlertFilter: false,
      showTypeCommandFilter: false,
      showResultAlertFilter: false,
      showTypeRateFilter: false,
      showTypeDeviceFilter: false,
      showTypeZoneFilter: false,
      showTypeAreaFilter: false,
      showTypeVehicleFilter: false,
    },
    filterNameList: "",
    has_filters: false
  },
  mutations: {
    setFilterNameList(state, value) {
      state.filterNameList = value;
    },
    setFilterConfig(state, config) {
      const system_role = securedWebStorage.getItem("role")
      // console.log('setFilterConfig', config)
      // console.log(category)
      // console.log(config.showCompanyFilter)
      state.filterConfig.showConfigFilter = config.showConfigFilter || false;
      state.filterConfig.showDateStartFilter = config.showDateStartFilter || false;
      state.filterConfig.showDateEndFilter = config.showDateEndFilter || false;
      state.filterConfig.withTime = config.withTime || false;
      state.filterConfig.showClientFilter = config.showClientFilter || false;
      state.filterConfig.showZoneFilter = config.showZoneFilter || false;
      state.filterConfig.showZonesFilter = config.showZonesFilter || false;
      state.filterConfig.showTypeFilter = config.showTypeFilter || false;
      state.filterConfig.showStatusFilter = config.showStatusFilter || false;
      state.filterConfig.showPlanFilter = config.showPlanFilter || false;
      state.filterConfig.showTextFilter = config.showTextFilter || false;
      state.filterConfig.showImeiFilter = config.showImeiFilter || false;
      state.filterConfig.showPlateFilter = config.showPlateFilter || false;
      state.filterConfig.showAliasFilter = config.showAliasFilter || false;
      state.filterConfig.showUserFilter = config.showUserFilter || false;
      state.filterConfig.showNameFilter = config.showNameFilter || false;
      state.filterConfig.showEmailFilter = config.showEmailFilter || false;
      state.filterConfig.showPhoneFilter = config.showPhoneFilter || false;
      state.filterConfig.showBrandFilter = config.showBrandFilter || false;
      state.filterConfig.showModelFilter = config.showModelFilter || false;
      state.filterConfig.showSpeedFilter = config.showSpeedFilter || false;
      state.filterConfig.showSpeedTypeFilter = config.showSpeedTypeFilter || false;
      state.filterConfig.showMileageFilter = config.showMileageFilter || false;
      state.filterConfig.showMileageTypeFilter = config.showMileageTypeFilter || false;
      state.filterConfig.showMinuteFilter = config.showMinuteFilter || false;
      state.filterConfig.showMinuteTypeFilter = config.showMinuteTypeFilter || false;
      state.filterConfig.showDaysFilter = config.showDaysFilter || false;
      state.filterConfig.showDaysTypeFilter = config.showDaysTypeFilter || false;
      state.filterConfig.showPlatesFilter = config.showPlatesFilter || false;
      state.filterConfig.showPlatesPlateFilter = config.showPlatesPlateFilter || false;
      state.filterConfig.showMassivePlatesFilter = config.showMassivePlatesFilter || false;
      state.filterConfig.showMassiveChasisNumbersFilter = config.showMassiveChasisNumbersFilter || false;
      state.filterConfig.showVehicleGroupsFilter = config.showVehicleGroupsFilter || false;
      state.filterConfig.showCompanyFilter = (config.showCompanyFilter && system_role == 'WISETRACK_ADMIN') ? true : false;
      // Acota los selectores al ámbito MIGPS PROTECT (mandantes con el feature
      // vigente, patentes con el equipamiento).
      state.filterConfig.protectOnlyFilter = config.protectOnlyFilter || false;
      state.filterConfig.showHighwayFilter = config.showHighwayFilter || false;
      state.filterConfig.showPorchFilter = config.showPorchFilter || false;
      state.filterConfig.showStatusAlertFilter = config.showStatusAlertFilter || false;
      state.filterConfig.showTypeAlertFilter = config.showTypeAlertFilter || false;
      state.filterConfig.showTypeCommandFilter = config.showTypeCommandFilter || false;
      state.filterConfig.showResultAlertFilter = config.showResultAlertFilter || false;
      state.filterConfig.showTypeRateFilter = config.showTypeRateFilter || false;
      state.filterConfig.showTypeDeviceFilter = config.showTypeDeviceFilter || false;
      state.filterConfig.showTypeZoneFilter = config.showTypeZoneFilter || false;
      state.filterConfig.showTypeAreaFilter = config.showTypeAreaFilter || false;
      state.filterConfig.showTypeVehicleFilter = config.showTypeVehicleFilter || false;
      // state.has_filters = Object.values(state.filterConfig).filter((key, index) => index !== 0).some((value) => value);
      // console.log('-----setFilterConfig, has_filters:', state.has_filters);

      // console.log('mutations setFilterConfig', state.filterConfig)
    },
    setDefaultDateStartFilter(state, value) {
      // console.log('--------setDefaultDateStartFilter', value)
      state.defaultDateStartFilter = value;
    },
    setDefaultDateEndFilter(state, value) {
      state.defaultDateEndFilter = value;
    },
    setDateStartFilter(state, value) {
      state.dateStartFilter = value;
    },
    setDateEndFilter(state, value) {
      state.dateEndFilter = value;
    },
    setAllField(state, value) {
      state.allField = value;
    },
    setDefaultFieldFilter(state, value) {
      state.defaultFieldFilter = value;
    },
    setFieldFilter(state, value) {
      state.fieldFilter = value;
    },
    setClientFilter(state, value) {
      state.clientFilter = value;
    },
    setZonesFilter(state, value) {
      state.zonesFilter = value;
    },
    setZoneFilter(state, value) {
      state.zoneFilter = value;
    },
    setTypeFilter(state, value) {
      state.typeFilter = value;
    },
    setStatusFilter(state, value) {
      state.statusFilter = value;
    },
    setPlanFilter(state, value) {
      state.planFilter = value;
    },
    setTextFilter(state, value) {
      state.textFilter = value;
    },
    setImeiFilter(state, value) {
      state.imeiFilter = value;
    },
    setPlateFilter(state, value) {
      state.plateFilter = value;
    },
    setAliasFilter(state, value) {
      state.aliasFilter = value;
    },
    setUserFilter(state, value) {
      state.userFilter = value;
    },
    setNameFilter(state, value) {
      state.nameFilter = value;
    },
    setEmailFilter(state, value) {
      state.emailFilter = value;
    },
    setPhoneFilter(state, value) {
      state.phoneFilter = value;
    },
    setBrandFilter(state, value) {
      state.brandFilter = value;
    },
    setModelFilter(state, value) {
      state.modelFilter = value;
    },
    setSpeedFilter(state, value) {
      state.speedFilter = value;
    },
    setSpeedTypeFilter(state, value) {
      state.speedTypeFilter = value;
    },
    setMileageFilter(state, value) {
      state.mileageFilter = value;
    },
    setMileageTypeFilter(state, value) {
      state.mileageTypeFilter = value;
    },
    setMinuteFilter(state, value) {
      state.minuteFilter = value;
    },
    setMinuteTypeFilter(state, value) {
      state.minuteTypeFilter = value;
    },
    setDaysFilter(state, value) {
      state.daysFilter = value;
    },
    setDaysTypeFilter(state, value) {
      state.daysTypeFilter = value;
    },
    setPlatesFilter(state, value) {
      state.platesFilter = value;
    },
    setPlatesPlateFilter(state, value) {
      state.platesPlateFilter = value;
    },
    setMassivePlatesFilter(state, value) {
      state.massivePlatesFilter = value;
    },
    setMassiveChasisNumbersFilter(state, value) {
      state.massiveChasisNumbersFilter = value;
    },
    setVehicleGroupsFilter(state, value) {
      state.vehicleGroupsFilter = value;
    },
    setCompanyFilter(state, value) {
      state.companyFilter = value;
    },
    setHighwayFilter(state, value) {
      state.highwayFilter = value;
    },
    setPorchFilter(state, value) {
      state.porchFilter = value;
    },
    setStatusAlertFilter(state, value) {
      state.statusAlertFilter = value;
    },
    setResultAlertFilter(state, value) {
      state.resultAlertFilter = value;
    },
    setTypeAlertFilter(state, value) {
      state.typeAlertFilter = value;
    },
    setTypeCommandFilter(state, value) {
      state.typeCommandFilter = value;
    },
    setTypeRateFilter(state, value) {
      state.typeRateFilter = value;
    },
    setTypeDeviceFilter(state, value) {
      state.typeDeviceFilter = value;
    },
    setTypeZoneFilter(state, value) {
      state.typeZoneFilter = value;
    },    
    setTypeAreaFilter(state, value) {
      state.typeAreaFilter = value;
    },
    setTypeVehicleFilter(state, value) {
      state.typeVehicleFilter = value;
    }, 
    resetFilters(state) {
      // console.log('resetFilters')
      state.defaultDateStartFilter = ''
      state.defaultDateEndFilter =''
      state.dateStartFilter = ''
      state.dateEndFilter =''
      state.allField = []
      state.defaultFieldFilter = []
      state.fieldFilter = []
      state.textFilter = '';
      state.clientFilter = '';
      state.zonesFilter = '';
      state.zoneFilter = '';
      state.typeFilter = '';
      state.statusFilter = '';
      state.planFilter = '';
      state.imeiFilter = '';
      state.plateFilter = '';
      state.aliasFilter = '';
      state.userFilter = '';
      state.nameFilter = '';
      state.emailFilter = '';
      state.phoneFilter = '';
      state.brandFilter = '';
      state.modelFilter = '';
      state.speedFilter = 0;
      state.speedTypeFilter = 0;
      state.mileageFilter = 0;
      state.mileageTypeFilter = 0;
      state.minuteFilter = 0;
      state.minuteTypeFilter = 0;
      state.daysFilter = 0;
      state.daysTypeFilter = 0;
      state.platesFilter = [];
      state.platesPlateFilter = [];
      state.massivePlatesFilter = "";
      state.massiveChasisNumbersFilter = "";
      state.vehicleGroupsFilter = [];
      state.companyFilter = "";
      state.filterNameList = '';
      state.highwayFilter = "";
      state.porchFilter = "";
      state.statusAlertFilter = '';
      state.typeAlertFilter = '';
      state.typeCommandFilter = '';
      state.resultAlertFilter = '';
      state.typeRateFilter = '';
      state.typeDeviceFilter = '';
      state.typeZoneFilter = '';
      state.typeAreaFilter = '';
      state.typeVehicleFilter = '';
      // console.log("resetFilters", state.defaultDateStartFilter, state.defaultDateEndFilter)
    },
  },
  actions: {
  },
  getters: {
    filterConfig: state => state.filterConfig,
    defaultDateStartFilter: state => state.defaultDateStartFilter,
    defaultDateEndFilter: state => state.defaultDateEndFilter,
    dateStartFilter: state => state.dateStartFilter,
    dateEndFilter: state => state.dateEndFilter,
    allField: state => state.allField,
    defaultFieldFilter: state => state.defaultFieldFilter,
    fieldFilter: state => state.fieldFilter,
    clientFilter: state => state.clientFilter,
    zonesFilter: state => state.zonesFilter,
    zoneFilter: state => state.zoneFilter,
    typeFilter: state => state.typeFilter,
    statusFilter: state => state.statusFilter,    
    planFilter: state => state.planFilter,
    textFilter: state => state.textFilter,
    imeiFilter: state => state.imeiFilter,
    plateFilter: state => state.plateFilter,
    aliasFilter: state => state.aliasFilter,
    userFilter: state => state.userFilter,
    nameFilter: state => state.nameFilter,
    emailFilter: state => state.emailFilter,
    phoneFilter: state => state.phoneFilter,
    brandFilter: state => state.brandFilter,
    modelFilter: state => state.modelFilter,
    speedFilter: state => state.speedFilter,
    speedTypeFilter: state => state.speedTypeFilter,
    mileageFilter: state => state.mileageFilter,
    mileageTypeFilter: state => state.mileageTypeFilter,
    minuteFilter: state => state.minuteFilter,
    minuteTypeFilter: state => state.minuteTypeFilter,
    daysFilter: state => state.daysFilter,
    daysTypeFilter: state => state.daysTypeFilter,
    platesFilter: state => state.platesFilter,
    platesPlateFilter: state => state.platesPlateFilter,
    massivePlatesFilter: state => state.massivePlatesFilter,
    massiveChasisNumbersFilter: state => state.massiveChasisNumbersFilter,
    vehicleGroupsFilter: state => state.vehicleGroupsFilter,
    companyFilter: state => state.companyFilter,
    filterNameList: state => state.filterNameList,
    highwayFilter: state => state.highwayFilter,
    porchFilter: state => state.porchFilter,
    statusAlertFilter: state => state.statusAlertFilter,
    typeAlertFilter: state => state.typeAlertFilter,
    typeCommandFilter: state => state.typeCommandFilter,
    resultAlertFilter: state => state.resultAlertFilter,
    typeRateFilter: state => state.typeRateFilter,
    typeDeviceFilter: state => state.typeDeviceFilter,
    typeZoneFilter:  state => state.typeZoneFilter,
    typeAreaFilter:  state => state.typeAreaFilter,
    typeVehicleFilter:  state => state.typeVehicleFilter,
  },
}
